export default "__VITE_ASSET__CmUv$WJ1__"